"use client"

import { Logo } from "@/components/ui/logo"

export function Footer() {
  return (
    <footer className="bg-background border-t border-border px-6 py-4 mt-auto">
      <div className="flex items-center justify-between text-sm text-muted-foreground">
        <div className="flex items-center space-x-4">
          <Logo size={20} className="flex-shrink-0" />
          <span>© 2025 DLOM & Blockage Calculator</span>
        </div>
        <div className="flex items-center space-x-4">
          <a href="/support" className="hover:text-foreground transition-colors">
            Support
          </a>
          <span>•</span>
          <a href="/documentation" className="hover:text-foreground transition-colors">
            Documentation
          </a>
        </div>
      </div>
    </footer>
  )
}
